exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card{box-shadow:0 4px 24px 0 rgb(34 41 47/10%);border-radius:.428rem}@media (max-width:944px){.md-flex-small-100{margin-top:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-004f592e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/dashboard/salesReports.vue
// module id = 1341
// module chunks = 0